<interacta-dialog [isOpen]="isOpen()" (closing)="closeDialog.emit()">
    <h6 class="shrink-0 typo-t6" title>
        {{ 'SHARED.COMMUNITY_PICKER.SELECT_COMMUNITY' | translate }}
    </h6>

    @if (caption(); as text) {
        <p class="mb-16 typo-sm text-text-mid-contrast" subtitle>{{ text }}</p>
    }

    @if (nameFilterControl(); as control) {
        <interacta-dialog-search
            class="mb-16"
            search
            [control]="control"
            [iconPosition]="'right'"
            [label]="'UI.BUTTON.SEARCH' | translate"
        />
    }

    @if (workspaceList().length || isFetching() || recentCommunities()) {
        <div class="flex min-h-0 grow flex-col" content>
            @if (recentCommunities(); as communities) {
                <div class="mb-16 shrink-0 px-2">
                    <p class="typo-sm-bold">
                        {{
                            'SHARED.COMMUNITY_PICKER.RECENT_COMMUNITIES'
                                | translate
                        }}
                    </p>
                    <ul>
                        @for (community of communities; track community.id) {
                            <li data-testid="recent-community">
                                <button
                                    class="flex min-h-32 w-full items-center gap-x-8 rounded-4"
                                    type="button"
                                    (click)="communitySelected.emit(community)"
                                >
                                    <interacta-icon
                                        class="size-24 shrink-0"
                                        [icon]="'community'"
                                    />
                                    <span
                                        class="line-clamp-2 grow text-left typo-xs-bold wrap-break-word"
                                        >{{ community.name }}</span
                                    >
                                </button>
                            </li>
                        }
                    </ul>
                </div>
            }

            @if (workspaceList().length) {
                <div class="flex min-h-0 grow flex-col">
                    @if (recentCommunities()) {
                        <span class="mb-4 shrink-0 typo-sm-bold text-text">
                            {{ 'SHARED.COMMUNITY_PICKER.HOME' | translate }}
                        </span>
                    }
                    <div
                        class="min-h-0 grow overflow-y-auto px-2"
                        interactaScrollTracker
                        [wheelScrollOnly]="true"
                        (scrolled)="onScrolled($event.endReached)"
                    >
                        <ul #workspaceListEl>
                            @for (
                                workspace of workspaceList();
                                track workspace.id;
                                let last = $last
                            ) {
                                <li
                                    class="py-4"
                                    [attr.aria-setsize]="
                                        isPaged() ? -1 : workspaceList().length
                                    "
                                >
                                    <button
                                        class="w-full rounded-4 text-left"
                                        type="button"
                                        [attr.aria-expanded]="
                                            accordionStates()[workspace.id]
                                                ?.isOpen ?? true
                                        "
                                        (click)="toggleWorkspace(workspace.id)"
                                    >
                                        <div
                                            class="ml-8 flex h-full shrink-0 items-center py-4 text-text-mid-contrast hover:text-text"
                                        >
                                            <interacta-icon
                                                class="mr-8 size-24"
                                                [icon]="'workspace'"
                                            />
                                            <div class="flex grow items-center">
                                                <span
                                                    class="line-clamp-2 grow typo-xs-bold-uppercase wrap-break-word"
                                                    >{{ workspace.name }}</span
                                                >
                                                <interacta-icon
                                                    class="size-24"
                                                    [icon]="
                                                        (accordionStates()[
                                                            workspace.id
                                                        ]?.isOpen ?? true)
                                                            ? 'chevron-small-up'
                                                            : 'chevron-small-down'
                                                    "
                                                />
                                            </div>
                                        </div>
                                    </button>

                                    @if (
                                        accordionStates()[workspace.id]
                                            ?.isOpen ?? true
                                    ) {
                                        <ul>
                                            @for (
                                                community of workspace.communities;
                                                track community.id
                                            ) {
                                                <li>
                                                    <button
                                                        class="flex w-full items-center rounded-4 pl-8 text-left text-text-mid-contrast hover:text-text"
                                                        type="button"
                                                        (click)="
                                                            communitySelected.emit(
                                                                community
                                                            )
                                                        "
                                                    >
                                                        <interacta-icon
                                                            class="mr-8 size-24 shrink-0"
                                                            [icon]="'community'"
                                                        />
                                                        <span
                                                            class="line-clamp-2 grow typo-xs-bold wrap-break-word"
                                                            >{{
                                                                community.name
                                                            }}</span
                                                        >
                                                    </button>
                                                </li>
                                            }
                                        </ul>
                                    }
                                </li>
                                @if (!last) {
                                    <interacta-separator [thickness]="'soft'" />
                                }
                            }
                        </ul>

                        @if (isPaged() && hasNextPage()) {
                            <interacta-load-more
                                class="py-8"
                                [autoFocusLoader]="true"
                                [isLoading]="isFetching()"
                                [label]="'SHARED.SHOW_MORE' | translate"
                                [size]="'regular'"
                                (loadMore)="onNextPage()"
                            />
                        }
                    </div>
                </div>
            }
        </div>
    } @else if (!isFetching()) {
        <interacta-dialog-description>
            {{ emptyLabel() | translate }}
        </interacta-dialog-description>
    }
</interacta-dialog>
